export const auctionDetailsBidsStyle = {
  wrapper: {
    marginTop: '24px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: '200px',
    borderRadius: '8px',
    background: 'var(--default-white)',
    padding: '12px 0',
    marginBottom: '10px',
  },

  searchButton: {
    textTransform: 'capitalize',
    width: '200px',

    '& svg': {
      width: '24px',
      height: '24px',

      '& path': {
        fill: 'var(--default-white)',
      },
    },
  },

  tableContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },

  container: {
    padding: '0px',
    marginBottom: '20px',
  },

  table: {
    maxWidth: '970px',
    tableLayout: 'fixed',
  },

  tableHeader: {
    '& > :nth-of-type(1)': {
      textTransform: 'capitalize',
      width: '11%',
    },
    '& > :nth-of-type(2)': {
      width: '17%',
    },
    '& > :nth-of-type(3)': {
      width: '17%',
    },
    '& > :nth-of-type(4)': {
      width: '11%',
    },
    '& > :nth-of-type(5)': {
      width: '27%',
    },
    '& > :nth-of-type(6)': {
      width: '27%',
    },
    '& > :nth-of-type(7)': {
      textTransform: 'capitalize',
      width: '16%',
    },
  },

  tableBody: {
    '& > :nth-of-type(5)': {
      fontWeight: 700,
    },

    '& > :nth-of-type(7)': {
      paddingRight: '20px',
    },

    '& .MuiTableCell-root': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      height: '42px',
      paddingTop: '8px !important',
      paddingBottom: '8px !important',
    },
  },

  bodyCell: {
    display: 'flex',
    gap: '12px',
  },

  bodyCellImage: {
    marginLeft: '-8px',
  },

  bodyCellImageContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  bodyCellImageContentName: {
    fontWeight: '700 !important',
  },

  bodyCellImageContentCategory: {
    color: 'var(--neutral-300) !important',
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '100px',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    marginTop: 'auto',
    paddingTop: '12px',
  },

  footerSpacer: {
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    gap: '24px',
    bottom: '24px',
    maxWidth: '1170px',
    width: '100%',
    height: '80px',
    padding: '0 100px',
    background: 'var(--default-white)',
    left: 'calc(50% - 585px)',
    borderRadius: '0 0 8px 8px',

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },
};
